// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: bracket/model/BracketPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ModifiersPayload } from "../../common/model/ModifiersPt";
import { WeightClassPayload } from "../../fight/model/FightPt";
import {
  AgeDivisionPayload,
  ageDivisionPayloadFromJSON,
  ageDivisionPayloadToJSON,
} from "../../fight/model/enums/AgeDivisionPt";
import {
  FightSportPayload,
  fightSportPayloadFromJSON,
  fightSportPayloadToJSON,
} from "../../fight/model/enums/FightSportPt";
import { GenderPayload, genderPayloadFromJSON, genderPayloadToJSON } from "../../fight/model/enums/GenderPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.bracket.model";

/** 편성 규모 — 운영자가 대진을 어디부터 시작할지 고른다 */
export enum BracketSizePayload {
  /** BRACKET_SIZE_AUTO - 인원에 맞춰 2의 거듭제곱으로 자동 결정 */
  BRACKET_SIZE_AUTO = 0,
  /** BRACKET_SIZE_QUARTER_FINAL - 8강 (슬롯 8개) */
  BRACKET_SIZE_QUARTER_FINAL = 1,
  /** BRACKET_SIZE_SEMI_FINAL - 4강 (슬롯 4개) */
  BRACKET_SIZE_SEMI_FINAL = 2,
  /** BRACKET_SIZE_FINAL - 결승 (슬롯 2개) */
  BRACKET_SIZE_FINAL = 3,
  UNRECOGNIZED = -1,
}

export function bracketSizePayloadFromJSON(object: any): BracketSizePayload {
  switch (object) {
    case 0:
    case "BRACKET_SIZE_AUTO":
      return BracketSizePayload.BRACKET_SIZE_AUTO;
    case 1:
    case "BRACKET_SIZE_QUARTER_FINAL":
      return BracketSizePayload.BRACKET_SIZE_QUARTER_FINAL;
    case 2:
    case "BRACKET_SIZE_SEMI_FINAL":
      return BracketSizePayload.BRACKET_SIZE_SEMI_FINAL;
    case 3:
    case "BRACKET_SIZE_FINAL":
      return BracketSizePayload.BRACKET_SIZE_FINAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BracketSizePayload.UNRECOGNIZED;
  }
}

export function bracketSizePayloadToJSON(object: BracketSizePayload): string {
  switch (object) {
    case BracketSizePayload.BRACKET_SIZE_AUTO:
      return "BRACKET_SIZE_AUTO";
    case BracketSizePayload.BRACKET_SIZE_QUARTER_FINAL:
      return "BRACKET_SIZE_QUARTER_FINAL";
    case BracketSizePayload.BRACKET_SIZE_SEMI_FINAL:
      return "BRACKET_SIZE_SEMI_FINAL";
    case BracketSizePayload.BRACKET_SIZE_FINAL:
      return "BRACKET_SIZE_FINAL";
    case BracketSizePayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** 경기 상태 */
export enum BracketMatchStatusPayload {
  BRACKET_MATCH_STATUS_UNKNOWN = 0,
  /** BRACKET_MATCH_SCHEDULED - 예정 */
  BRACKET_MATCH_SCHEDULED = 1,
  /** BRACKET_MATCH_BYE - 부전승 (상대가 없어 다음 라운드로 자동 진출한 자리) */
  BRACKET_MATCH_BYE = 2,
  UNRECOGNIZED = -1,
}

export function bracketMatchStatusPayloadFromJSON(object: any): BracketMatchStatusPayload {
  switch (object) {
    case 0:
    case "BRACKET_MATCH_STATUS_UNKNOWN":
      return BracketMatchStatusPayload.BRACKET_MATCH_STATUS_UNKNOWN;
    case 1:
    case "BRACKET_MATCH_SCHEDULED":
      return BracketMatchStatusPayload.BRACKET_MATCH_SCHEDULED;
    case 2:
    case "BRACKET_MATCH_BYE":
      return BracketMatchStatusPayload.BRACKET_MATCH_BYE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BracketMatchStatusPayload.UNRECOGNIZED;
  }
}

export function bracketMatchStatusPayloadToJSON(object: BracketMatchStatusPayload): string {
  switch (object) {
    case BracketMatchStatusPayload.BRACKET_MATCH_STATUS_UNKNOWN:
      return "BRACKET_MATCH_STATUS_UNKNOWN";
    case BracketMatchStatusPayload.BRACKET_MATCH_SCHEDULED:
      return "BRACKET_MATCH_SCHEDULED";
    case BracketMatchStatusPayload.BRACKET_MATCH_BYE:
      return "BRACKET_MATCH_BYE";
    case BracketMatchStatusPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * 대진표 (TB_BRACKET 과 1:1)
 *
 * 한 대진표는 「대회 + 종목 + 부 + 성별 + 체급」 하나를 덮는다.
 * 체급은 종목 안에서만 유일하므로 sport 와 weightClass 는 반드시 한 쌍으로 읽는다.
 *
 * **대회 전에 짜는 표다.** 경기 진행 · 결과는 이 시스템이 다루지 않으므로 승자 · 진행 상태가 없다.
 */
export interface BracketPayload {
  /** 고유 id */
  id: string;
  /** 대회 고유 id */
  tournamentId: string;
  /** 종목 */
  sport: FightSportPayload;
  /** 부 */
  division: AgeDivisionPayload;
  /** 성별 */
  gender: GenderPayload;
  /** 체급 */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 편성 요청 규모 (운영자가 고른 값) */
  size: BracketSizePayload;
  /** 실제 1라운드 슬롯 수 (2 · 4 · 8 · 16 · 32). 인원보다 크면 그만큼 부전승이 생긴다 */
  slotCount: number;
  /** 라운드 수 (slotCount = 8 이면 3 — 8강 · 4강 · 결승) */
  roundCount: number;
  /** 편성 시드 (같은 시드 + 같은 선수 목록이면 같은 대진이 나온다) */
  drawSeed: string;
  /** 경기 목록 (라운드 · 경기 순번 오름차순) */
  match: BracketMatchPayload[];
  /** 공개 여부 — 운영자가 켜야 공개 조회에 나간다 (편성은 곧 공개가 아니다) */
  isPublic: boolean;
  /** 수정 정보 */
  modifiers: ModifiersPayload | undefined;
}

/** 대진표 목록 한 줄 (체급 선택 카드용 — 경기 목록을 싣지 않는다) */
export interface BracketSummaryPayload {
  /** 고유 id */
  id: string;
  /** 대회 고유 id */
  tournamentId: string;
  /** 종목 */
  sport: FightSportPayload;
  /** 부 */
  division: AgeDivisionPayload;
  /** 성별 */
  gender: GenderPayload;
  /** 체급 */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 참가 선수 수 (부전승 슬롯은 세지 않는다) */
  playerCount: number;
  /** 경기 수 */
  matchCount: number;
  /** 라운드 수 */
  roundCount: number;
  /** 공개 여부 (관리자 목록에서 쓴다 — 공개 조회에는 공개된 것만 내려간다) */
  isPublic: boolean;
}

/**
 * 경기 (TB_BRACKET_MATCH 과 1:1)
 *
 * 1라운드만 선수가 앉아 있고, 상위 라운드는 대진표의 골격으로만 만들어 둔다
 * (부전승으로 자동 진출한 자리만 미리 채워진다).
 */
export interface BracketMatchPayload {
  /** 고유 id */
  id: string;
  /** 대진표 고유 id */
  bracketId: string;
  /** 라운드 번호 (1 = 첫 라운드) */
  roundNo: number;
  /** 라운드 안 경기 순번 (1부터) */
  matchNo: number;
  /** 라운드 표시명 (예: "8강" · "준결승" · "결승") */
  roundName: string;
  /** 홈 선수 (비어 있으면 상위 라운드의 미정 자리다) */
  homePlayer:
    | BracketMatchPlayerPayload
    | undefined;
  /** 어웨이 선수 (비어 있으면 부전승 또는 미정) */
  awayPlayer:
    | BracketMatchPlayerPayload
    | undefined;
  /** 경기 상태 */
  status: BracketMatchStatusPayload;
  /**
   * 대회 전체 경기 순번 (기존 종이 대진표의 「N경기」와 같다)
   *
   * 라운드 단위로 매긴다 — 대회의 1라운드 전부가 1..N, 그 다음 4강, 마지막이 결승이다.
   * 저장하지 않고 조회할 때 계산한다 (체급을 재편성해도 번호가 다시 맞는다).
   */
  orderNo: number;
}

/** 경기에 배치된 선수 (신청 선수 스냅샷이 아니라 참조 + 표시용 값이다) */
export interface BracketMatchPlayerPayload {
  /** 신청 선수 고유 id (빈 문자열이면 빈 자리) */
  playerId: string;
  /** 선수명 */
  playerName: string;
  /** 소속 체육관명 */
  gymName: string;
  /** 신청 체중 (kg 소수점 문자열) */
  weightKg: string;
}

function createBaseBracketPayload(): BracketPayload {
  return {
    id: "",
    tournamentId: "",
    sport: 0,
    division: 0,
    gender: 0,
    weightClass: undefined,
    size: 0,
    slotCount: 0,
    roundCount: 0,
    drawSeed: "",
    match: [],
    isPublic: false,
    modifiers: undefined,
  };
}

export const BracketPayload: MessageFns<BracketPayload> = {
  encode(message: BracketPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.tournamentId !== "") {
      writer.uint32(18).string(message.tournamentId);
    }
    if (message.sport !== 0) {
      writer.uint32(24).int32(message.sport);
    }
    if (message.division !== 0) {
      writer.uint32(32).int32(message.division);
    }
    if (message.gender !== 0) {
      writer.uint32(40).int32(message.gender);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(50).fork()).join();
    }
    if (message.size !== 0) {
      writer.uint32(56).int32(message.size);
    }
    if (message.slotCount !== 0) {
      writer.uint32(64).int32(message.slotCount);
    }
    if (message.roundCount !== 0) {
      writer.uint32(72).int32(message.roundCount);
    }
    if (message.drawSeed !== "") {
      writer.uint32(82).string(message.drawSeed);
    }
    for (const v of message.match) {
      BracketMatchPayload.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.isPublic !== false) {
      writer.uint32(112).bool(message.isPublic);
    }
    if (message.modifiers !== undefined) {
      ModifiersPayload.encode(message.modifiers, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.size = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.slotCount = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.roundCount = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.drawSeed = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.match.push(BracketMatchPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.isPublic = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.modifiers = ModifiersPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      size: isSet(object.size) ? bracketSizePayloadFromJSON(object.size) : 0,
      slotCount: isSet(object.slotCount) ? globalThis.Number(object.slotCount) : 0,
      roundCount: isSet(object.roundCount) ? globalThis.Number(object.roundCount) : 0,
      drawSeed: isSet(object.drawSeed) ? globalThis.String(object.drawSeed) : "",
      match: globalThis.Array.isArray(object?.match)
        ? object.match.map((e: any) => BracketMatchPayload.fromJSON(e))
        : [],
      isPublic: isSet(object.isPublic) ? globalThis.Boolean(object.isPublic) : false,
      modifiers: isSet(object.modifiers) ? ModifiersPayload.fromJSON(object.modifiers) : undefined,
    };
  },

  toJSON(message: BracketPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.size !== 0) {
      obj.size = bracketSizePayloadToJSON(message.size);
    }
    if (message.slotCount !== 0) {
      obj.slotCount = Math.round(message.slotCount);
    }
    if (message.roundCount !== 0) {
      obj.roundCount = Math.round(message.roundCount);
    }
    if (message.drawSeed !== "") {
      obj.drawSeed = message.drawSeed;
    }
    if (message.match?.length) {
      obj.match = message.match.map((e) => BracketMatchPayload.toJSON(e));
    }
    if (message.isPublic !== false) {
      obj.isPublic = message.isPublic;
    }
    if (message.modifiers !== undefined) {
      obj.modifiers = ModifiersPayload.toJSON(message.modifiers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketPayload>, I>>(base?: I): BracketPayload {
    return BracketPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketPayload>, I>>(object: I): BracketPayload {
    const message = createBaseBracketPayload();
    message.id = object.id ?? "";
    message.tournamentId = object.tournamentId ?? "";
    message.sport = object.sport ?? 0;
    message.division = object.division ?? 0;
    message.gender = object.gender ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.size = object.size ?? 0;
    message.slotCount = object.slotCount ?? 0;
    message.roundCount = object.roundCount ?? 0;
    message.drawSeed = object.drawSeed ?? "";
    message.match = object.match?.map((e) => BracketMatchPayload.fromPartial(e)) || [];
    message.isPublic = object.isPublic ?? false;
    message.modifiers = (object.modifiers !== undefined && object.modifiers !== null)
      ? ModifiersPayload.fromPartial(object.modifiers)
      : undefined;
    return message;
  },
};

function createBaseBracketSummaryPayload(): BracketSummaryPayload {
  return {
    id: "",
    tournamentId: "",
    sport: 0,
    division: 0,
    gender: 0,
    weightClass: undefined,
    playerCount: 0,
    matchCount: 0,
    roundCount: 0,
    isPublic: false,
  };
}

export const BracketSummaryPayload: MessageFns<BracketSummaryPayload> = {
  encode(message: BracketSummaryPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.tournamentId !== "") {
      writer.uint32(18).string(message.tournamentId);
    }
    if (message.sport !== 0) {
      writer.uint32(24).int32(message.sport);
    }
    if (message.division !== 0) {
      writer.uint32(32).int32(message.division);
    }
    if (message.gender !== 0) {
      writer.uint32(40).int32(message.gender);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(50).fork()).join();
    }
    if (message.playerCount !== 0) {
      writer.uint32(64).int32(message.playerCount);
    }
    if (message.matchCount !== 0) {
      writer.uint32(72).int32(message.matchCount);
    }
    if (message.roundCount !== 0) {
      writer.uint32(80).int32(message.roundCount);
    }
    if (message.isPublic !== false) {
      writer.uint32(88).bool(message.isPublic);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketSummaryPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketSummaryPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.playerCount = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.matchCount = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.roundCount = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.isPublic = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketSummaryPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      playerCount: isSet(object.playerCount) ? globalThis.Number(object.playerCount) : 0,
      matchCount: isSet(object.matchCount) ? globalThis.Number(object.matchCount) : 0,
      roundCount: isSet(object.roundCount) ? globalThis.Number(object.roundCount) : 0,
      isPublic: isSet(object.isPublic) ? globalThis.Boolean(object.isPublic) : false,
    };
  },

  toJSON(message: BracketSummaryPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.playerCount !== 0) {
      obj.playerCount = Math.round(message.playerCount);
    }
    if (message.matchCount !== 0) {
      obj.matchCount = Math.round(message.matchCount);
    }
    if (message.roundCount !== 0) {
      obj.roundCount = Math.round(message.roundCount);
    }
    if (message.isPublic !== false) {
      obj.isPublic = message.isPublic;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketSummaryPayload>, I>>(base?: I): BracketSummaryPayload {
    return BracketSummaryPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketSummaryPayload>, I>>(object: I): BracketSummaryPayload {
    const message = createBaseBracketSummaryPayload();
    message.id = object.id ?? "";
    message.tournamentId = object.tournamentId ?? "";
    message.sport = object.sport ?? 0;
    message.division = object.division ?? 0;
    message.gender = object.gender ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.playerCount = object.playerCount ?? 0;
    message.matchCount = object.matchCount ?? 0;
    message.roundCount = object.roundCount ?? 0;
    message.isPublic = object.isPublic ?? false;
    return message;
  },
};

function createBaseBracketMatchPayload(): BracketMatchPayload {
  return {
    id: "",
    bracketId: "",
    roundNo: 0,
    matchNo: 0,
    roundName: "",
    homePlayer: undefined,
    awayPlayer: undefined,
    status: 0,
    orderNo: 0,
  };
}

export const BracketMatchPayload: MessageFns<BracketMatchPayload> = {
  encode(message: BracketMatchPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.bracketId !== "") {
      writer.uint32(18).string(message.bracketId);
    }
    if (message.roundNo !== 0) {
      writer.uint32(24).int32(message.roundNo);
    }
    if (message.matchNo !== 0) {
      writer.uint32(32).int32(message.matchNo);
    }
    if (message.roundName !== "") {
      writer.uint32(42).string(message.roundName);
    }
    if (message.homePlayer !== undefined) {
      BracketMatchPlayerPayload.encode(message.homePlayer, writer.uint32(50).fork()).join();
    }
    if (message.awayPlayer !== undefined) {
      BracketMatchPlayerPayload.encode(message.awayPlayer, writer.uint32(58).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(72).int32(message.status);
    }
    if (message.orderNo !== 0) {
      writer.uint32(96).int32(message.orderNo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketMatchPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketMatchPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bracketId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.roundNo = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.matchNo = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.roundName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.homePlayer = BracketMatchPlayerPayload.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.awayPlayer = BracketMatchPlayerPayload.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.orderNo = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketMatchPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      bracketId: isSet(object.bracketId) ? globalThis.String(object.bracketId) : "",
      roundNo: isSet(object.roundNo) ? globalThis.Number(object.roundNo) : 0,
      matchNo: isSet(object.matchNo) ? globalThis.Number(object.matchNo) : 0,
      roundName: isSet(object.roundName) ? globalThis.String(object.roundName) : "",
      homePlayer: isSet(object.homePlayer) ? BracketMatchPlayerPayload.fromJSON(object.homePlayer) : undefined,
      awayPlayer: isSet(object.awayPlayer) ? BracketMatchPlayerPayload.fromJSON(object.awayPlayer) : undefined,
      status: isSet(object.status) ? bracketMatchStatusPayloadFromJSON(object.status) : 0,
      orderNo: isSet(object.orderNo) ? globalThis.Number(object.orderNo) : 0,
    };
  },

  toJSON(message: BracketMatchPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.bracketId !== "") {
      obj.bracketId = message.bracketId;
    }
    if (message.roundNo !== 0) {
      obj.roundNo = Math.round(message.roundNo);
    }
    if (message.matchNo !== 0) {
      obj.matchNo = Math.round(message.matchNo);
    }
    if (message.roundName !== "") {
      obj.roundName = message.roundName;
    }
    if (message.homePlayer !== undefined) {
      obj.homePlayer = BracketMatchPlayerPayload.toJSON(message.homePlayer);
    }
    if (message.awayPlayer !== undefined) {
      obj.awayPlayer = BracketMatchPlayerPayload.toJSON(message.awayPlayer);
    }
    if (message.status !== 0) {
      obj.status = bracketMatchStatusPayloadToJSON(message.status);
    }
    if (message.orderNo !== 0) {
      obj.orderNo = Math.round(message.orderNo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketMatchPayload>, I>>(base?: I): BracketMatchPayload {
    return BracketMatchPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketMatchPayload>, I>>(object: I): BracketMatchPayload {
    const message = createBaseBracketMatchPayload();
    message.id = object.id ?? "";
    message.bracketId = object.bracketId ?? "";
    message.roundNo = object.roundNo ?? 0;
    message.matchNo = object.matchNo ?? 0;
    message.roundName = object.roundName ?? "";
    message.homePlayer = (object.homePlayer !== undefined && object.homePlayer !== null)
      ? BracketMatchPlayerPayload.fromPartial(object.homePlayer)
      : undefined;
    message.awayPlayer = (object.awayPlayer !== undefined && object.awayPlayer !== null)
      ? BracketMatchPlayerPayload.fromPartial(object.awayPlayer)
      : undefined;
    message.status = object.status ?? 0;
    message.orderNo = object.orderNo ?? 0;
    return message;
  },
};

function createBaseBracketMatchPlayerPayload(): BracketMatchPlayerPayload {
  return { playerId: "", playerName: "", gymName: "", weightKg: "" };
}

export const BracketMatchPlayerPayload: MessageFns<BracketMatchPlayerPayload> = {
  encode(message: BracketMatchPlayerPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.playerId !== "") {
      writer.uint32(10).string(message.playerId);
    }
    if (message.playerName !== "") {
      writer.uint32(18).string(message.playerName);
    }
    if (message.gymName !== "") {
      writer.uint32(26).string(message.gymName);
    }
    if (message.weightKg !== "") {
      writer.uint32(34).string(message.weightKg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BracketMatchPlayerPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBracketMatchPlayerPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.playerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.playerName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.gymName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.weightKg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BracketMatchPlayerPayload {
    return {
      playerId: isSet(object.playerId) ? globalThis.String(object.playerId) : "",
      playerName: isSet(object.playerName) ? globalThis.String(object.playerName) : "",
      gymName: isSet(object.gymName) ? globalThis.String(object.gymName) : "",
      weightKg: isSet(object.weightKg) ? globalThis.String(object.weightKg) : "",
    };
  },

  toJSON(message: BracketMatchPlayerPayload): unknown {
    const obj: any = {};
    if (message.playerId !== "") {
      obj.playerId = message.playerId;
    }
    if (message.playerName !== "") {
      obj.playerName = message.playerName;
    }
    if (message.gymName !== "") {
      obj.gymName = message.gymName;
    }
    if (message.weightKg !== "") {
      obj.weightKg = message.weightKg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BracketMatchPlayerPayload>, I>>(base?: I): BracketMatchPlayerPayload {
    return BracketMatchPlayerPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BracketMatchPlayerPayload>, I>>(object: I): BracketMatchPlayerPayload {
    const message = createBaseBracketMatchPlayerPayload();
    message.playerId = object.playerId ?? "";
    message.playerName = object.playerName ?? "";
    message.gymName = object.gymName ?? "";
    message.weightKg = object.weightKg ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
